import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { canEditPetition, Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'petition-update-declare-victory',
		path: '/p/:slug/victory',
		component: loadable(async () => import(/* webpackChunkName: "pages/petition_update_declare_victory" */ './index'), {
			exportName: 'PetitionUpdateDeclareVictory',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support', canEditPetition('slug')],
		},
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: false,
			seo: false,
		},
	},
];
